<template>
  <div>
    <div class="allContent" :class="$store.state.user.isNested && 'nestedHeader'">
      <!--      todo -->
      <!--      headerBgi.png-->
      <div class="apply_header_box">
        <!--        <div class="productName">榮耀貸</div>-->
        <!--        <div class="productName productApplication">-->
        <!--          {{ $store.state.user.isNested ? l.home_fullAppApplication : l.home_fullH5Application }}-->
        <!--        </div>-->
      </div>
      <div class="apply_container">
        <Notice/>
        <!-- 主要内容 -->
        <div class="mainContent">
          <!-- 选择贷款额度 -->
          <div class="container">
            <div class="change_limit_con">
              <!--                        <img class="applyImg" src="@/assets/home/money.png" alt="" />-->
              <div class="title">
                <span>{{ l.home_max_loan_amount }}</span>
              </div>
              <div class="divCenter">
                <div class="curLoanMoney">
                  <span class="symbol">NT$</span>5,000
                  <!--                  {{ formatMoney(loan) }}-->
                  -
                  <span class="symbol">NT$</span>300,000
                </div>
                <!--              <div class="descinfo">-->
                <!--                <div class="descinfoItem">{{ l.home_three_apply }}</div>-->
                <!--                <div class="descinfoItem">-->
                <!--                  {{ l.home_loan_data_more_than }}-->
                <!--                </div>-->
                <!--              </div>-->
              </div>

              <div class="container_submit">
                <!-- 申请贷款 -->
                <div class="commit_con">
                  <Button
                      size="normal"
                      type="info"
                      block
                      class="button_font"
                      @click="handleLoanBtn"
                  >{{ l.home_apply_for_loan }}
                    <img class="button_font_icon" src="@/assets/home/btn_icon.png" alt="">
                  </Button>
                  <div class="commit_quota">
                    <!-- <img class="commit_quota_img" src="@/assets/home/Imark@2x.png" alt=""> -->
                    <div class="commit_quota_text">{{ l.home_minute_review_minutes_funding }}</div>
                  </div>
                  <!--                <div class="commit_checkbox">-->
                  <!--                  <Checkbox-->
                  <!--                      v-model="checked"-->
                  <!--                      checked-color="#00819F"-->
                  <!--                      shape="square"-->
                  <!--                      icon-size="14"-->
                  <!--                  >-->
                  <!--                    <template #icon="props">-->
                  <!--                      <img-->
                  <!--                          class="commit_checkbox_img"-->
                  <!--                          :src="-->
                  <!--                    props.checked-->
                  <!--                      ? require('@/assets/home/hook2@2x.png')-->
                  <!--                      : require('@/assets/home/hook@2x.png')-->
                  <!--                  "-->
                  <!--                      /></template-->
                  <!--                    >-->
                  <!--                    <span class="read">{{ l.home_privacy_policy }}</span>-->
                  <!--                    &lt;!&ndash; @click.stop="$router.push('/privacyPolicy')" &ndash;&gt;-->
                  <!--                    <span @click.stop="showAuditBox(0)">{{-->
                  <!--                        l.home_toast_fail_btn-->
                  <!--                      }}</span>-->
                  <!--                  </Checkbox>-->
                  <!--                </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="conf && conf.line" style="height: 10px;"></div>
        <div class="apkUrl_box" v-if="conf && conf.line">
          <div class="apkUrl_img_box"><img src="@/assets/home/google.png" alt=""></div>
          <div class="apkUrl_text">點擊下方按鈕到Google商店下載</div>
          <Button
              size="normal"
              type="info"
              block
              class="apkUrl_btn"
              @click="openUrl"
          >下載
          </Button>
        </div>
        <div class="professional">
          <div class="professional_title">專業借款服務</div>
          <div class="professional_list">
            <div v-for="(item,index) in professionalList" :key="index" class="professional_list_item">
              <img class="professional_list_item_img" :src="item.imgUrl" alt="">
              <div class="professional_list_item_text">
                <div class="professional_list_item_title">{{ item.title }}</div>
                <div class="professional_list_item_desc" v-html="item.desc"></div>
              </div>
            </div>
          </div>
          <div class="professional_desc">
            汽機車借款、支客票貼現、房地融資、精品典當、降息代償、企業周轉、小額借款、大額融資周轉，只要您有資金需求，榮耀貸都能為您量身訂製最適合的金融借貸服務。
          </div>
        </div>
        <div class="introduce"></div>

        <!--        <div class="desc_content">-->
        <!--          <div class="hintContent">-->
        <!--            <div class="hintItem">-->
        <!--              <div class="hintImgBox">-->
        <!--                <img class="hintImg" src="@/assets/home/rz@2x.png" alt=""/>-->
        <!--              </div>-->
        <!--              <div class="hintText">{{ l.home_authentication }}</div>-->
        <!--            </div>-->
        <!--            <div class="hintItem">-->
        <!--              <div class="hintImgBox">-->
        <!--                <img class="hintImg" src="@/assets/home/zl@2x.png" alt=""/>-->
        <!--              </div>-->
        <!--              <div class="hintText">{{ l.home_fill_information }}</div>-->
        <!--            </div>-->
        <!--            <div class="hintItem">-->
        <!--              <div class="hintImgBox">-->
        <!--                <img class="hintImg" src="@/assets/home/sq@2x.png" alt=""/>-->
        <!--              </div>-->
        <!--              <div class="hintText">{{ l.home_toast_success }}</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          &lt;!&ndash;        <div class="bannerImg">&ndash;&gt;-->
        <!--          &lt;!&ndash;          <Swipe&ndash;&gt;-->
        <!--          &lt;!&ndash;              :autoplay="isShowFrame ? '0' : '3000'"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :loop="!isShowFrame"&ndash;&gt;-->
        <!--          &lt;!&ndash;              indicator-color="#FFFFFF"&ndash;&gt;-->
        <!--          &lt;!&ndash;              @change="changeSwipe"&ndash;&gt;-->
        <!--          &lt;!&ndash;          >&ndash;&gt;-->
        <!--          &lt;!&ndash;            <Swipe-item&ndash;&gt;-->
        <!--          &lt;!&ndash;                @click="showFrame(index)"&ndash;&gt;-->
        <!--          &lt;!&ndash;                v-for="(image, index) in images"&ndash;&gt;-->
        <!--          &lt;!&ndash;                :key="index"&ndash;&gt;-->
        <!--          &lt;!&ndash;            >&ndash;&gt;-->
        <!--          &lt;!&ndash;              <div class="swipeImg">&ndash;&gt;-->
        <!--          &lt;!&ndash;                <img v-lazy="image"/>&ndash;&gt;-->
        <!--          &lt;!&ndash;              </div>&ndash;&gt;-->
        <!--          &lt;!&ndash;            </Swipe-item>&ndash;&gt;-->
        <!--          &lt;!&ndash;          </Swipe>&ndash;&gt;-->
        <!--          &lt;!&ndash;        </div>&ndash;&gt;-->
        <!--          &lt;!&ndash;          <div class="address">&ndash;&gt;-->
        <!--          &lt;!&ndash;            <div class="addressTitle"><img class="addressTitle_img" src="@/assets/home/address.png">{{
          &ndash;&gt;-- >
          < !-- &lt; ! & ndash;                l.home_address & ndash;&gt;-- >
          < !-- &lt; ! & ndash;
        }}:&ndash;&gt;-->
        <!--          &lt;!&ndash;            </div>&ndash;&gt;-->
        <!--          &lt;!&ndash;            <div class="addressDesc">&ndash;&gt;-->
        <!--          &lt;!&ndash;              720A Đ. Điện Biên Phủ, Vinhomes Tân Cảng, Bình Thạnh, Thành phố Hồ Chí Minh, VN&ndash;&gt;-->
        <!--          &lt;!&ndash;            </div>&ndash;&gt;-->
        <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
        <!--          <div style="height: 30px;"></div>-->
        <!--        </div>-->
      </div>
    </div>
    <SwipeHint
        :imageIndex="imageIndex"
        :show="isShowFrame"
        @closePopup="closePopup"
    />
    <AuditBox
        :boxIndex="textIndex"
        :show="isShowAuditBox"
        @closePopup="closeAuditBoxPopup"
    />
  </div>
</template>

<script>
import {
  Button,
  // Checkbox,
  // Swipe, SwipeItem,
  Toast
} from "vant";

//import ExpandMore from "@/components/expandMore";
import SwipeHint from "@/components/swipeHint";
import AuditBox from "@/components/auditBox";
import buriedPoint from "@/mixins/buriedPoint";
import Notice from "@/components/notice";
import l from "@/locales";

import {formatMoney} from "@/utils";
import {config} from "@/services/user";

export default {
  components: {
    Button,
    // Checkbox,
    // Swipe,
    // SwipeItem,
    SwipeHint,
    AuditBox,
    Notice,
  },
  mixins: [buriedPoint],
  props: {
    loadProduct: {
      type: Object,
    },
  },
  watch: {
    loadProduct(val) {
      this.curLoadProduct = val;
      this.init();
      this.initNotices();
    },
  },
  created() {
    this.curLoadProduct = this.loadProduct;
    this.$nextTick(() => {
      this.init();
      this.initNotices();
    });
  },
  data() {
    return {
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      loan: 30000,
      checked: true,
      min: 10000,
      max: 30000,
      stepNumber: 5000,
      images: [
        require("@/assets/home/banner.png"),
        require("@/assets/home/banner2.png"),
        require("@/assets/home/banner3.png"),
      ],
      imageIndex: 0,
      isShowFrame: false,
      textIndex: 0,
      isShowAuditBox: false,
      conf: undefined,
      notices: [],
      curLoadProduct: {},
      professionalList: [
        {
          title: "汽機車借款",
          desc: "現金車、貸款車、公司車、機車… 任何車輛皆可辦理。原車使用，無貸款車輛利率更優惠！",
          imgUrl: require("@/assets/home/profess1.png")
        },
        {
          title: "房地融資代辦",
          desc: "不限屋齡及坪數，銀行不可貸，榮耀讓您貸！<br/>短期週轉更優惠，利率1%起。",
          imgUrl: require("@/assets/home/profess2.png")
        },
        {
          title: "工商企業融資",
          desc: "公司、店面、攤販皆可辦理，給您銀行外的信用額度。資金週轉免煩惱，短期週轉最快速。",
          imgUrl: require("@/assets/home/profess3.png")
        },
        {
          title: "支客票貼現",
          desc: "公司票、個人票、客票…您有支票通通借！<br/>高額度5～1000萬無上限，利率再給最優惠！",
          imgUrl: require("@/assets/home/profess4.png")
        },
        {
          title: "代償降息專案",
          desc: "整合各種貸款，幫您提高額度、給您最低利率。<br/>讓您資金週轉最省利！",
          imgUrl: require("@/assets/home/profess5.png")
        },
        {
          title: "精品典當",
          desc: "萬物皆可當，專業鑑定。<br/>免保人、免聯徵，借款額度業界最高！",
          imgUrl: require("@/assets/home/profess6.png")
        },
      ]
    };
  },
  computed: {
    showStepNum() {
      return this.loan / this.stepNumber;
    },
  },
  methods: {
    formatMoney,
    async init() {
      console.log(
          "this.$store.state.user.userInfo",
          this.$store.state.user.userInfo
      );
      // if (this.$store.state.user.userInfo) {
      // queryproducts2().then((res) => {
      //   this.loadProduct = res.result.find((v) => {
      //     return v.enable == 1;
      //   });
      //   let productId = this.loadProduct.productId;
      //   console.log(this.loadProduct, productId);
      //   this.min = this.loadProduct.minOverdueNum;
      //   this.max = this.loadProduct.maxOverdueNum;
      //   this.stepNumber = this.loadProduct.stepAmount;
      //   this.loan = this.loadProduct.maxOverdueNum;
      //   // confirmLoan
      // });
      //   this.loan = this.curLoadProduct.mchAmount;
      // } else {
      let conf = JSON.parse(localStorage.getItem("config") || "{}");
      if (!conf) {
        let res = await config();
        conf = res.result;
      }
      // console.log("conf", conf.result);
      this.conf = conf;
      this.loan = this.conf.loan_max_amount;
      // this.loan = this.conf.loan_max_amount.includes(",")
      //     ? Number(this.conf.loan_max_amount.replace(/,/g, ""))
      //     : Number(this.conf.loan_max_amount);
      // }
    },
    openUrl() {
      window.location.href = this.conf.line;
    },
    copyMed(str) {
      const input = document.createElement("input");
      input.setAttribute("value", str);
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      Toast(this.l.bank_copy_suc);
    },
    copyonCopy() {
      Toast(this.l.bank_copy_suc);
    },
    copynError() {
      Toast(this.l.bank_copy_err);
    },
    maximumNumber(a, b) {
      let num;
      while (a != b) {
        if (a > b) {
          a = a - b;
        } else {
          b = b - a;
        }
      }
      num = a;
      // return (a*b)/num;
      return num;
    },
    closePopup() {
      this.isShowFrame = false;
    },
    closeAuditBoxPopup() {
      this.isShowAuditBox = false;
    },
    showFrame(index) {
      this.imageIndex = index;
      this.isShowFrame = true;
    },
    showAuditBox(index) {
      this.textIndex = index;
      this.isShowAuditBox = true;
    },
    changeSwipe(index) {
      this.imageIndex = index;
    },
    handleLoanBtn() {
      if (!this.checked) {
        Toast.success(this.l.home_toast_fail);
        return;
      }
      this.$emit("handleLoanBtn", this.loan);
    },
    initNotices() {
      const phoneNumss = ["3", "7", "8", "9"];
      // 获取1-10之间的随机数
      while (this.notices.length < 100) {
        let amount = Math.floor(Math.random() * 485) + 15;
        let num = Math.floor(Math.random() * 99999999) + 10000000;
        let phoneNum = Math.floor(Math.random() * 4);
        let phone = phoneNumss[phoneNum] + num;
        amount = amount * 100000;
        phone = phone.replace(/(\d{3})\d+(\d{3})/, "$1***$2");

        let amount2 = Math.floor(Math.random() * 200) + 300;
        let num2 = Math.floor(Math.random() * 99999999) + 10000000;
        let phoneNum2 = Math.floor(Math.random() * 4);
        let phone2 = phoneNumss[phoneNum2] + num2;
        amount2 = amount2 * 100000;
        phone2 = phone2.replace(/(\d{3})\d+(\d{3})/, "$1***$2");
        const arr = [
          {
            amount,
            phone,
          },
          {
            amount: amount2,
            phone: phone2,
          },
        ];
        this.notices.push(...arr);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.allContent {
  position: relative;
  width: 100%;

  background: #FFFFFF;
  background-size: 100%;


  .apply_header_box {
    background: url("~@/assets/home/headerBgi.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 156px;
    padding-top: 60px;
    box-sizing: border-box;

    .productName {
      padding-left: 45px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    .productApplication {
      margin-top: 20px;
    }
  }

  .apply_container {
    margin-top: 10px;
    //transform: translateY(-24px);
    padding-bottom: 50px;
  }

  .noticeBox {
    padding: 0 15px;

    .notice {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      box-sizing: border-box;
      margin: 0 auto;

      height: 36px;
      background: #ffffff;
      border-radius: 6px;

      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #324353;

      .notice_img {
        width: 18px;
        height: 18px;
        margin-left: 20px;
        margin-right: 6px;
      }

      /deep/ .van-swipe__track--vertical {
        height: 36px !important;
      }

      .van-swipe-item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  .mainContent {
    .container {
      // padding: 0 15px;
      margin: 0 auto;
      width: 100%;
      // box-sizing: border-box;

      .change_limit_con {
        position: relative;
        margin: 0 15px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #333333;
        box-sizing: border-box;

        width: calc(100% - 30px);
        height: 248px;

        background: linear-gradient( 180deg, #D9F8FC 0%, #FFFFFF 100%);
        border-radius: 10px;
        border: 1px solid #85C6CE;

        // &::before {
        //   content: '';
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 150px;
        //   border-radius: 10px;
        //   background: linear-gradient(180deg, #E6F0FB 0%, rgba(255, 255, 255, 0) 100%);
        // }

        .applyImg {
          position: absolute;
          left: 10px;
          top: 20px;
          width: 80px;
          height: 48px;
        }

        .title {
          position: absolute;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
          width: 100%;
          text-align: center;
          box-sizing: border-box;

          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #445144;

        }

        .symbol {
          margin-right: 6px;
        }

        .divCenter {
          position: absolute;
          top: 60px;
          left: 50%;
          transform: translateX(-50%);

          //width: 225px;
          width: calc(100% - 30px);
          height: 57px;
          background: url("~@/assets/home/lineWire.png") no-repeat;
          background-size: 100% 100%;
          padding: 0 10px;
          box-sizing: border-box;

          display: flex;
          align-items: center;
          justify-content: center;

          .curLoanMoney {
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #2A333C;

          }

          .symbol {
            font-size: 16px;
          }

          .descinfo {
            position: absolute;
            top: 90px;
            left: 20px;

            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #19AD23;
            line-height: 20px;

            display: flex;
            align-items: center;
            justify-content: space-between;

            width: calc(100% - 40px);
            padding-top: 16px;

            .descinfoItem {
              position: relative;
              flex: 1;
              margin-left: 8px;
              padding: 0 6px;

              &::before {
                position: absolute;
                left: -2px;
                top: 50%;
                border-radius: 50%;
                transform: translate(-100%, -50%);
                content: "";
                width: 8px;
                height: 8px;
                background: #19AD23;
              }
            }
          }
        }
      }
    }
  }

  .container_submit {
    position: absolute;
    top: 137px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;

    .commit_con {
      padding: 0 20px;

      .commit_checkbox {
        width: 275px;
        margin: 10px auto;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3f414c;
        display: flex;
        align-items: center;
        justify-content: center;

        .commit_checkbox_img {
          width: 12px;
          height: 12px;
        }

        /deep/ .van-checkbox {
          display: flex;
          align-items: flex-start;
        }

        span {
          color: #00819F;
        }

        .read {
          color: #232425;
          margin-right: 6px;
        }
      }

      .button_font {
        margin: 0 35px;
        width: calc(100% - 70px);
        border: none;

        border-radius: 25px;

        height: 48px;
        background: #B8D6E2;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #00819F;

        .button_font_icon{
          width: 6px;
          height: 8px;
          margin-left: 6px;
        }

      }

      .commit_quota {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;

        .commit_quota_img {
          width: 18px;
          height: 18px;
          margin-right: 5px;

        }

        .commit_quota_text {
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #445144;
        }
      }
    }
  }

  .bannerImg {
    position: relative;
    box-sizing: border-box;
    margin: 0 20px;
    width: calc(100% - 40px);
    height: 110px;

    .swipeImg {
      position: relative;
      width: 100%;
      height: 110px;

      img {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 335px;
        height: 100%;
        border-radius: 14px;
        overflow: hidden;
      }
    }
  }

  .desc_content {
    //background: #FFFFFF;
    background: #F5F5F5;
    border-radius: 20px 20px 0px 0px;
    margin-top: 20px;

  }

  .hintContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15px;
    margin-bottom: 20px;

    height: 111px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #DDDDDD;

    .hintItem {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      flex-wrap: wrap;

      &:not(:last-child) {
        &::before {
          position: absolute;
          top: 22.5px;
          right: 0;
          width: 45px;
          height: 1px;
          background: #D5E7FF;
          transform: translateX(50%);
          content: "";
        }
      }

      .hintImgBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        .hintImg {
          width: 45px;
          height: 45px;
        }
      }

      .hintText {
        margin-top: 10px;
        width: 100%;
        text-align: center;
        height: 18px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #53718B;

      }
    }
  }

  .apkUrl_box {
    margin: 0 15px;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    background: linear-gradient( 180deg, #D9F8FC 0%, #FFFFFF 100%);
    border-radius: 10px;
    border: 1px solid #85C6CE;

    .apkUrl_img_box {
      img {
        width: 68px;
        height: 24px;
      }
    }

    .apkUrl_text {
      margin-top: 6px;
      width: 100%;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #838E9D;
    }

    .apkUrl_btn {
      margin-top: 10px;
      box-sizing: border-box;
      width: 155px;
      height: 35px;
      background: transparent;
      border: 1px solid #00819F;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #00819F;
      border-radius: 35px;
    }
  }

  .professional {
    padding: 15px 0;
    box-sizing: border-box;
    margin-top: 15px;

    background: linear-gradient( 180deg, #D9F8FC 0%, #FFFFFF 100%);
    border-radius: 10px 10px 0px 0px;
    border: 1px solid #85C6CE;

    .professional_title {
      position: relative;
      margin: 0 auto;
      margin-bottom: 10px;

      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3f414c;
      width: fit-content;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: -10px;
        transform: translate(-100%, -50%);
        background: url("~@/assets/userInfo/title1.png") no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 10px;
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: -10px;
        transform: translate(100%, -50%);
        background: url("~@/assets/userInfo/title2.png") no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 10px;
      }
    }

    .professional_list {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 15px;
      box-sizing: border-box;
      .professional_list_item {
        margin: 7.5px 0;
        padding-bottom: 10px;
        box-sizing: border-box;
        width: 166px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #85C6CE;
        overflow: hidden;
        .professional_list_item_img {
          width: 100%;
          height: 104px;
        }

        .professional_list_item_text {
          .professional_list_item_title {
            margin: 8px 8px 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 13px;
            color: #33393D;
          }

          .professional_list_item_desc {
            margin-left: 8px;
            margin-right: 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #5F656D;
            line-height: 17px;
          }
        }
      }
    }

    .professional_desc{
      margin-top: 5px;
      background: #DFEFF6;
      padding: 15px;
      box-sizing: border-box;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #5F656D;
      line-height: 17px;
    }
  }
  .introduce{
    background: url("~@/assets/home/introduce.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 375px;
    margin-bottom: 30px;
  }

  .address {
    margin-top: 20px;
    padding: 0 20px;

    .addressTitle {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #366085;


      .addressTitle_img {
        width: 12px;
        height: 18px;
        margin-right: 5px;
      }
    }

    .addressDesc {
      margin-top: 5px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #838E9D;
      line-height: 18px;

    }
  }
}

.myInfo {
  margin-top: 20px;
  background: #201f24;
  box-shadow: 0px -6px 12px 0px rgba(0, 0, 0, 0.2);
  padding: 20px 18px;

  .myInfo_title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #f9dab1;
    letter-spacing: 1px;
  }

  .myInfo_info {
    margin-top: 20px;

    .myInfo_info_item {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7be96;
      margin-bottom: 10px;

      img {
        width: 22px;
        height: 22px;
        margin-right: 27px;
      }

      .myInfo_info_item_text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #d7be96;
      }
    }
  }

  .myInfo_desc {
    padding-top: 10px;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
  }

  .myInfo_href_box {
    display: flex;
    justify-content: space-between;

    .myInfo_href {
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #d7be96;
      border-bottom: 1px solid #d7be96;
    }
  }
}
</style>
